export default {
  tabs: {
    present: "当前对话",
    history: "历史对话",
    screening: "筛选条件",
  },
  form: {
    readStatus: "阅读状态",
    assignmentStatus: "分配状态",
    agentName: "客服名",
    vipLevel: "用户VIP等级",
    all: "全部",
    unread: "未读",
    read: "已读",
    unassigned: "未分配",
    assigned: "已分配",
    user: "用户ID搜索",
    totalMessages: "共计 {count} 条消息",
    inputPlaceholder: "请输入内容",
    replyStatus: "回复状态",
  },
  action: {
    search: "查询",
    reset: "重置",
  },
  serviceList: {
    allocation: "自动分配新对话",
    configuration: "更多配置",
    blockUser: "拉黑",
    transferChat: "转接",
    endConversation: "结束会话",
    platform: "平台",
    balance: "余额",
    total_recharge_amount: "累计充值金额",
    deposit_withdrawal_difference: "充提差",
    subordinate_recharge_count: "下级充值人数",
    subordinate_recharge_amount: "下级充值金额",
    id: "Id",
    noData: "请选择一个对话，开始聊天",
    moreRecords: "查看更多记录",
    noMoreRecords: "没有更多记录了",
    upload: "发送图片",
    image: "图片",
    video: "视频",
    file: "文件",
    score: "评分",
    uploadVideo: "发送视频",
    uploadFile: "发送文件",
    videoTooLarge: "视频或文件大小不能超过100MB",
    assignAgent: "分配客服",
    closeConversation: "关闭会话",
    allocationSuccess: "分配成功",
    closeSession: "是否关闭此会话？",
    closeSelected: "是否关闭您所选择的会话？({total}条)",
    closeSuccess: "关闭成功",
    unReadMessage: "是否将该会话消息标记成未读?",
    noCurrentConversation: "暂无会话",
    selectServiceForAllocation: "选择客服进行分配",
    userRating: "用户评分",
    serviceFeedback: "客服{name}很有耐心，非常迅速的帮我解决了问题！",
    recall: "删除",
    copyText: "复制文本",
    edit: "编辑",
    copyImage: "复制图片",
    downloadImage: "下载图片",
    downloadFile: "下载文件",
    reply: "回复",
    editLabel: "修改标签",
    bulkTransfer: "批量操作",
    transferService: "转接客服",
    bulkClose: "批量关闭",
    bulkOpen: "批量打开",
    all: "全选",
    messageUnRead: "消息未读",
    selectConversation: "请选择会话",
    mobile: "手机号",
    isGuest: "是否为游客",
    selectFilterRequired: "请选择筛选条件",
    reverse: "是否倒序",
    toggleSuccess: "切换成功",
  },
  distribution: {
    autoAssign: "自动分配对话",
    assignType: "选择要分配的对话类型",
    assign: "选择要分配的客服",
    all: "全部对话",
    existing: "存量对话",
    new: "新进对话",
    startAllocation: "开始分配",
    agentSelect: "请选择客服",
    enableAutoAssignment: "请打开自动分配",
  },
  time: {
    yesterday: "昨天",
    sunday: "星期日",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    date_format: "{month}月{day}日",
  },
};
